import { useState } from "react";
import { Loader2, UserRound } from "lucide-react";

export const PhoneProfileCompletion = ({ onComplete, busy, error }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [localError, setLocalError] = useState("");

  const submit = (event) => {
    event.preventDefault();
    const first = firstName.trim();
    const last = lastName.trim();
    if (first.length < 2 || last.length < 2) {
      setLocalError("Please enter your first and last name.");
      return;
    }
    setLocalError("");
    onComplete({ first_name: first, last_name: last });
  };

  return (
    <section
      className="mx-auto w-full max-w-md pt-10"
      data-testid="phone-profile-completion-screen"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-orange-100 text-[#FF5200]">
        <UserRound size={24} strokeWidth={2.3} />
      </div>
      <p className="mt-8 text-xs font-bold uppercase tracking-[0.18em] text-[#FF5200]">
        Welcome to Quick Door Now
      </p>
      <h1 className="mt-3 text-3xl font-black leading-tight text-slate-900">
        Please enter your details to continue.
      </h1>
      <p className="mt-3 text-sm leading-6 text-slate-500">
        This helps us keep your deliveries and order updates accurate.
      </p>

      <form className="mt-8 space-y-4" onSubmit={submit} data-testid="phone-profile-completion-form">
        <label className="block text-sm font-bold text-slate-800">
          First Name *
          <input
            data-testid="phone-profile-first-name-input"
            value={firstName}
            onChange={(event) => setFirstName(event.target.value)}
            autoComplete="given-name"
            disabled={busy}
            maxLength={50}
            className="mt-2 block w-full rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-sm font-semibold text-slate-900 outline-none transition-colors focus:border-[#FF5200] focus:ring-2 focus:ring-orange-100 disabled:cursor-not-allowed disabled:bg-slate-50"
          />
        </label>
        <label className="block text-sm font-bold text-slate-800">
          Last Name *
          <input
            data-testid="phone-profile-last-name-input"
            value={lastName}
            onChange={(event) => setLastName(event.target.value)}
            autoComplete="family-name"
            disabled={busy}
            maxLength={50}
            className="mt-2 block w-full rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-sm font-semibold text-slate-900 outline-none transition-colors focus:border-[#FF5200] focus:ring-2 focus:ring-orange-100 disabled:cursor-not-allowed disabled:bg-slate-50"
          />
        </label>
        {(localError || error) && (
          <p
            className="rounded-xl bg-red-50 p-3 text-sm font-medium text-red-700"
            data-testid="phone-profile-completion-error"
          >
            {localError || error}
          </p>
        )}
        <button
          data-testid="phone-profile-continue-button"
          disabled={busy}
          className="flex w-full items-center justify-center gap-2 rounded-2xl bg-[#FF5200] py-4 text-[15px] font-extrabold text-white shadow-lg shadow-orange-500/25 transition-transform active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-50"
        >
          {busy ? <Loader2 className="animate-spin" size={18} /> : "Continue"}
        </button>
      </form>
    </section>
  );
};